import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export interface IVideoInputSettingsProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class VideoInputSettings extends React.Component<IVideoInputSettingsProps> {
    public render() {
        return (
            <div className="container-fluid px-2 px-md-4">
                <div className="row">
                    <div className="col-md-4 py-2">
                        <h5>Coming Soon</h5>
                    </div>
                </div>
            </div>
        );
    }

    @observable
    private loading = false;
}
